"use client";

import { c as _c } from "react/compiler-runtime";
import { useAnimatedRating } from './hooks';
const RatingCircle = t0 => {
  const $ = _c(19);
  const {
    roundedRating,
    bgColor,
    label,
    shouldAnimate: t1
  } = t0;
  const shouldAnimate = t1 === undefined ? true : t1;
  const {
    displayValue,
    animatedProgress
  } = useAnimatedRating(roundedRating, shouldAnimate);
  const animatedPercentage = animatedProgress / 5 * 100;
  const animatedRotation = animatedPercentage / 100 * 360;
  const t2 = `${bgColor}30`;
  let t3;
  if ($[0] !== t2) {
    t3 = <div className="absolute inset-0 rounded-full" style={{
      border: "4px solid",
      borderColor: t2,
      transition: "border-color 0.6s ease-in-out"
    }} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = `conic-gradient(from -90deg, ${bgColor} 0deg, ${bgColor} ${animatedRotation}deg, transparent ${animatedRotation}deg)`;
  let t5;
  if ($[2] !== t4) {
    t5 = <div className="absolute inset-0 rounded-full" style={{
      background: t4,
      clipPath: "circle(50% at 50% 50%)",
      WebkitClipPath: "circle(50% at 50% 50%)"
    }} />;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="absolute rounded-full" style={{
      width: "calc(100% - 8px)",
      height: "calc(100% - 8px)",
      top: "4px",
      left: "4px",
      backgroundColor: "white"
    }} />;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== bgColor) {
    t7 = {
      color: bgColor,
      transition: "color 0.6s ease-in-out"
    };
    $[5] = bgColor;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== displayValue || $[8] !== t7) {
    t8 = <div className="absolute inset-0 flex items-center justify-center z-10"><span className="text-xl font-bold font-poppins" style={t7}>{displayValue}</span></div>;
    $[7] = displayValue;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t3 || $[11] !== t5 || $[12] !== t8) {
    t9 = <div className="relative w-14 h-14 mb-1">{t3}{t5}{t6}{t8}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== label) {
    t10 = <span className="text-xs font-medium text-gray-700 font-poppins text-center">{label}</span>;
    $[14] = label;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t9) {
    t11 = <div className="flex flex-col items-center">{t9}{t10}</div>;
    $[16] = t10;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};
export default RatingCircle;